import {
  BaseDiner,
  CtdTicket,
  GetPosEndOfDayStatus,
  PaymentMethodOptionId,
  TicketStatus
} from 'src/app/models';
import { CtdSelectedDepartmentAccount } from 'src/app/store/pos-manager/closing-the-day/closing-the-day.model';

const ACTION: (action: string) => string = (action) =>
  '[ClosingTheDay] ' + action;

export class GetEndOfDayTickets {
  static readonly type = ACTION('Get end of day tickets');
  constructor(public readonly status: GetPosEndOfDayStatus) {}
}

export class CheckEndOfDayTickets {
  static readonly type = ACTION('Check end of day tickets');
  constructor(public readonly date: string) {}
}

export class VoidAllUnpaidTickets {
  static readonly type = ACTION('Void all unpaid tickets');
  constructor(public readonly pos_operator_id?: number) {}
}

export class CloseCtdTicket {
  static readonly type = ACTION('Close CTD ticket');
  constructor(public readonly device_ticket_uuid: string) {}
}

export class CloseCtdTicketSuccess {
  static readonly type = ACTION('Close CTD ticket success');
  constructor(
    public readonly device_ticket_uuid: string,
    public readonly ticketStatus: TicketStatus
  ) {}
}

export class CtdSelectPaymentMethod {
  static readonly type = ACTION('Select payment method');
  constructor(public readonly selectedMethodId: PaymentMethodOptionId) {}
}

export class CtdSelectBtrDiner {
  static readonly type = ACTION('Select Bill To Room Diner');
  constructor(public readonly diner: BaseDiner) {}
}

export class CtdSelectChargeAccount {
  static readonly type = ACTION('Select Charge Account');
  constructor(public readonly id: number) {}
}

export class CtdSelectChargeAccountDepartment {
  static readonly type = ACTION('Select Charge Account Department');
  constructor(public readonly selected: CtdSelectedDepartmentAccount) {}
}

export class CtdCloseAllPaidTickets {
  static readonly type = ACTION('Close all paid tickets');
  constructor(public readonly date: string) {}
}

export class CtdUpdateTicket {
  static readonly type = ACTION('Update CTD ticket');
  constructor(
    public readonly device_ticket_uuid: string,
    public readonly data: Partial<CtdTicket>
  ) {}
}
